import React, { Component, useState, useEffect, useCallback, useRef } from 'react';
import { loadingPrincipal } from '../../functions';
import '../../assets/css/unsubscribe.css'
import {API_URL} from '../../constants';
import axios from 'axios';


import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
    withRouter,
    useHistory,  // Acces to history object
    useParams,  // Get url params
  } from 'react-router-dom';



const Unsubscribe = props => {

    const OnSubmit = (event) => {
        var url = `${API_URL}UnsubscribeUX/`; 

        var formData = JSON.stringify({sMail: document.getElementById('email').value , sComentario: document.getElementById('comment').value});
        console.log(formData);
        axios.post(
            url,
            formData,
                { headers:  {
                                'Content-Type': 'application/json; charset=UTF-8' ,
                                'Accept': 'application/json'
                            }
                }
            )
        .then(response => response.data)
        .then((data) => {
            document.getElementById('email').value='';
            document.getElementById('comment').value='';
            document.getElementById('finish').style.display = "block";
        })
        .catch(error => {
        });
    }

    const email = useRef(useParams().email).current;
    loadingPrincipal(false);
    return ( 
        <div>
            
            <br/>
            <br/>

            <div class="col-lg-8 col-md-8 col-sm-12 pb-15 m-auto">
                <div class="bg-secondary rounded-lg px-3 py-4 p-sm-4">
                    <form class="needs-validation p-2" novalidate="">
                        <div class="form-group">
                            <h1 class="h2 pb-3 text-white" >¿Deseas cancelar tu suscripción?</h1>
                            <fieldset class="form-group mb-5">
                                <label class="text-muted text-white" for="forms-3-mail"><small>Correo electrónico</small></label>
                                <div class="form-check mb-2">
                                    <input class="form-check-input text-white" id="option-1" type="radio" name="gridRadios" value="option1" checked />
                                    <label class="form-check-label text-white" for="option-1">Quiero cancelar mi suscripción</label>
                                </div>
                                <div class="form-check mb-1">
                                    <input class="form-check-input text-white" id="option-2" type="radio" name="gridRadios" value="option2"/>
                                    <label class="form-check-label text-white" for="option-2">No quiero cancelar mi suscripción</label>
                                    </div>
                            </fieldset>
                            <label class="form-label text-white" for="email">Correo electrónico</label>
                            <input class="form-control" type="email" required="" id="email" value={email} />  
                            
                            <br/>
                            <br/>

                            <label class="form-label text-white" for="comment">Déjanos un comentario</label>
                            <input class="form-control" type="text" required="" id="comment"  />  
                        </div>
                        <button class="btn btn-primary" type="button" onClick={OnSubmit}>Quitar suscripción</button>
                    </form>
                </div>
                <br/>
                <div id={"finish"}  style={{display: 'none'}} class="bg-secondary rounded-lg px-3 py-4 p-sm-4">
                    <center>
                        <h1 className="text-white">Se ha removido su suscripción</h1>  
                    </center> 
                </div>
            </div>
            
            <br/>
            <br/>
        
        </div>
    );
    
}


export default Unsubscribe;

// export default class Unsubscribe extends Component {


//     constructor(props) {
//         super(props);
      
//         this.state = { 
//             resource: [],
//             response: [],
//             error: [],
//             key: 0,
//             clave: this.props.clave,
//             security: JSON.parse(localStorage.getItem('userBulletin'))
//           }
//       }


//     componentDidMount() {

//         loadingPrincipal(false);
//     }




//     render() {
//         console.log('Unsubscribe')
//         return ( 
//             <div id="notfound">
//                 <div className="notfound-bg">

//                 </div>
//                 <div className="notfound">
//                     <div className="notfound-404">
//                         <h2 id="show" style={{ color: '#d13520', display: 'none' }}> Se ha borrado su correo de nuestra base de datos </h2>
//                     </div>
                    
//                     <h4 id="message"  style={{ color: '#d13520' }}>Lamentamos que tengas que irte, dale clic al botón para no recibir nuestros boletines.</h4>

//                     <br/>

//                     <a id="button"  href="#"  onClick={(event) => this.handleClick(event)}  className="btn-primary">
//                         <span  style={{ color: '#fff', padding: '15px 15px 15px 15px '}}> 
//                         No deseo recibir el Boletín
//                         </span>
//                     </a>
                    
//                 </div>
//             </div>
//         )
//     }

// }